import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=31bf04dc&scoped=true&lang=pug&"
import script from "./DashboardLayout.vue?vue&type=script&lang=ts&"
export * from "./DashboardLayout.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardLayout.vue?vue&type=style&index=0&id=31bf04dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bf04dc",
  null
  
)

export default component.exports